import Table from "src/components/Common/UI/DndTable/Table";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import React from "react";
import { MisterIcon } from "@rtel/mister-icons";
import { Button } from "reactstrap";
import CreateUnit from "./CreateUnit";
import EditUnit from "./EditUnit";
import DeleteUnit from "./DeleteUnit";
import TableActionButtons from "src/components/Common/UI/DndTable/ActionButtons/TableActionButtons";
import { useUnitsDataViewLogic } from "./hooks/useUnitsDataViewLogic";
import Modal from "src/components/Common/UI/Modal/Modal";
import { Navigate } from "react-router-dom";


const UnitsDataView = () => {

  const {
    data,
    columns,
    loadingDone,
    setSelectedRowsOfTable,
    selectedRowsOfTable,
    actionEvent,
    closeActionModal,
    getModalTitleByAction,
    t,
    modalEvent,
    apiTotalRecords
  } = useUnitsDataViewLogic();

  const addUnitButton: React.FC = () => {
    return (
      <Button
        type="button"
        color="dark"
        onClick={ () => { actionEvent({action: "create"}); }}
        className="mb-1"
        size="sm"
        data-toggle="modal"
      >
        <MisterIcon name="Plus" size="sm" className="icon-light" /> {t(`Νέα Μονάδα`)}
      </Button>
    )
  };

  const ActionButtons: React.FC = () => (
    <TableActionButtons event={actionEvent} canEdit={selectedRowsOfTable.length > 0} canDelete={false} showDetails={selectedRowsOfTable.length > 0} />
  );

  return (
    <>
        {loadingDone && (
            <Table
                columns={columns}
                data={data}
                defaultOrderByKeyFilter={"id"}
                showNumberOfRows={true}
                rowSelection={true}
                setRowSelection={setSelectedRowsOfTable}
                multipleRowSelection={false}
                actionRowId={"id"}
                debugMode={false}
                noDataFoundTitle="No Units yet"
                isChangeOrderOrVisibilityEnable={false}
                ButtonsAreaLeft={ActionButtons}
                ButtonsAreaRight={addUnitButton}
                hiddenColumnsForUser={["deleted", "id"]}
                textPosition="center"
                maxHeight="33rem"
                numberOfRows={apiTotalRecords}
                numberOfRowsTitle="μονάδες"
            />
        )}

        <Modal
          isOpen={!!modalEvent.action}
          closeFilterModal={closeActionModal}
          title={getModalTitleByAction()}  
          size="md"
        >
          {modalEvent.action === "create" && <CreateUnit handleCloseModal={closeActionModal}/> }
          {modalEvent.action === "edit" && <EditUnit handleCloseModal={closeActionModal} unitId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
          {modalEvent.action === "delete" && <DeleteUnit handleCloseModal={closeActionModal} unitId={modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1} />}
        </Modal>

        {modalEvent.action === "showDetails" && 
          <Navigate to={`/configuration/unitconfiguration/detailspage/Units/unittype/${modalEvent.selectedRows ? modalEvent.selectedRows[0] : -1}/unitid`} />
        }

        {!loadingDone && <LoadingSpinner />}
    </>
  )
}

export default UnitsDataView;

